import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/translation.json';
import es from './locales/es/translation.json';

const getInitialLanguage = () => {
  if (typeof window === 'undefined') return 'es';

  const saved = window.localStorage.getItem('lang');
  if (saved === 'en' || saved === 'es') return saved;

  const nav = (window.navigator.language || 'es').toLowerCase();
  return nav.startsWith('en') ? 'en' : 'es';
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  lng: getInitialLanguage(),
  fallbackLng: 'es',
  interpolation: {
    escapeValue: false,
  },
});

i18n.on('languageChanged', (lng) => {
  if (typeof window === 'undefined') return;
  if (lng === 'en' || lng === 'es') {
    window.localStorage.setItem('lang', lng);
  }
});

export default i18n;
